
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".9","clip-path":"url(#clip0_1487_8218)"}},[_c('path',{attrs:{"d":"M3.214 3.094v1.031h3.572V3.094c0-.95-.8-1.719-1.786-1.719-.987 0-1.786.77-1.786 1.719zM1.786 4.125V3.094C1.786 1.386 3.226 0 5 0c1.775 0 3.214 1.386 3.214 3.094v1.031h.357C9.36 4.125 10 4.742 10 5.5v4.125C10 10.383 9.36 11 8.571 11H1.43C.64 11 0 10.383 0 9.625V5.5c0-.758.64-1.375 1.429-1.375h.357z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1487_8218"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h10v11H0z"}})])])])
          )
        }
      }
    